export type TExportHistoryItem = {
  item_key: string;
  thumbnail_url: string | null;
  full_size_url?: string | null;
};

export const mergeUniqueExportHistoryItems = <T extends TExportHistoryItem>(
  currentItems: readonly T[],
  incomingItems: readonly T[],
) => {
  const seenItemKeys = new Set(currentItems.map((item) => item.item_key));
  const mergedItems = [...currentItems];

  incomingItems.forEach((item) => {
    if (seenItemKeys.has(item.item_key)) return;
    seenItemKeys.add(item.item_key);
    mergedItems.push(item);
  });

  return mergedItems;
};

export const getExportHistoryGridImageUrl = (
  item: TExportHistoryItem,
  thumbnailFailed: boolean,
) => {
  if (item.thumbnail_url && !thumbnailFailed) return item.thumbnail_url;
  return item.full_size_url || null;
};
